import adapter from 'webrtc-adapter';

console.log(adapter.browserDetails.browser);

export * from './lib/tele-engine';
